import { getOrCreateEventBus, Publisher, Subscription } from '../services/event-bus/event-bus'

export interface ProductPriceChangedEventArgs {
  price: number
}

type ProductPriceChangedCallback = (publisher: Publisher, args: ProductPriceChangedEventArgs) => void;
const eventName = 'v1/product_price_changed'

export const subscribeToProductPriceChangedEvent = (callback: ProductPriceChangedCallback): Subscription => {
  const eventBus = getOrCreateEventBus()
  return eventBus.subscribe(eventName, callback)
}

export const publishProductPriceChangedEvent = (args: ProductPriceChangedEventArgs): void => {
  const eventBus = getOrCreateEventBus()
  const publisher = { name: 'add-to-cart-widget' }
  return eventBus.publish(eventName, publisher, args)
}
